export const CLEAR_HISTORY = 'CLEAR_HISTORY';
export const DELETE_HISTORY = 'DELETE_HISTORY';
export const SELECT_HISTORY = 'SELECT_HISTORY';

export const clearHistory = () => ({type: CLEAR_HISTORY});

export const deleteHistoryItem = (item) => ({...item, type: DELETE_HISTORY});
